import { render, staticRenderFns } from "./WeeklySelectDrink.vue?vue&type=template&id=122d89cb"
import script from "./WeeklySelectDrink.vue?vue&type=script&lang=js"
export * from "./WeeklySelectDrink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports